import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { listOrganizations } from "../service/organizationService";
import type { Organization } from "../types";

interface OrganizationsState {
  organizations: Organization[];
  loading: boolean;
}

const initialState: OrganizationsState = {
  organizations: [],
  loading: false,
};

export const loadOrganizations = createAsyncThunk("organizations/load", async () => {
  return await listOrganizations();
});

const organizationsSlice = createSlice({
  name: "organizations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadOrganizations.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadOrganizations.fulfilled, (state, action) => {
        state.loading = false;
        state.organizations = action.payload;
      })
      .addCase(loadOrganizations.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default organizationsSlice.reducer;